export const NO_AREA = {
  id: '47f248b2-94a8-4234-bf34-309dc19ebc49',
  name: 'Unassigned Items'
}